import React from "react"
import styled from "styled-components"
import { GoToButton } from "styleguide/components"
import { Col, Container, Row } from "styleguide/components/grid"
import Image from "styleguide/components/Image"
import { IconArrowRight } from "styleguide/icons"
import { uiColorToBaseColor } from "styleguide/styles/colors"
import { fontFamily } from "styleguide/styles/fonts"
import media from "styleguide/styles/media-queries"

const ComputerImage = ({ ...props }) => (
  <Image filename="computer.png" {...props} />
)
const BoardHand = ({ ...props }) => (
  <Image filename="board_hand.png" {...props} />
)

const Wrapper = styled.div`
  background-color: ${uiColorToBaseColor("black")};
  padding: 80px 0;
  min-height: 280px;
`

const FirstPart = styled.div`
  color: ${uiColorToBaseColor("lightestGray")};
  font-size: 26px;
  line-height: 40px;
  font-weight: 800;
  font-family: ${fontFamily("heading")};
`

const SecondPart = styled(FirstPart)`
  color: #fff;
`

const RightCol = styled(Col)`
  position: relative;

  ${media.tablet`
    padding-top: 64px;
    text-align: right;
  `}
`

const StyledBoardHand = styled.div`
  position: absolute;
  left: 120px;
  bottom: -50px;
  width: 240px;

  ${media.largeDesktop`
    left: 50px;
  `}

  ${media.desktop`
    left: 0px;
  `}

  ${media.tablet`
    width: 50%;
    bottom: auto;
    top: 64px;
    left: 16px;
  `}

  ${media.phone`
    left: 32px;
  `}
`

const StyledComputerImage = styled.div`
  width: 360px;
  position: absolute;
  right: 0;
  top: -120px;
  box-sizing: content-box;

  ${media.tablet`
    width: 75%;
    position: relative;
    top: 0;
    right: -25%;
  `}
`

const StyledGoToButton = styled(GoToButton)`
  margin-top: 40px;
  color: #fff;
  background-color: #ee2b16;
  font-weight: 500;

  &:hover {
    color: #fff;
  }

  ${media.tablet`
    padding-left: 32px;
    padding-right: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 16px;
  `}
`

const WhatWeHaveDone = () => (
  <Wrapper>
    <Container>
      <Row>
        <Col md={6} sm={12} xs={12}>
          <FirstPart>
            Are you looking for a software development partner who can
          </FirstPart>
          <SecondPart>
            develop modern, high-performance web apps and sites?
          </SecondPart>
          <StyledGoToButton
            size="XL"
            to="/recent-work/"
            icon={<IconArrowRight color="white" />}
          >
            See what we&apos;ve done
          </StyledGoToButton>
        </Col>
        <RightCol md={6} sm={12} xs={12}>
          <StyledComputerImage>
            <ComputerImage alt="woman programming" />
          </StyledComputerImage>
          <StyledBoardHand>
            <BoardHand alt="hand on board adjusting a fluxogram" />
          </StyledBoardHand>
        </RightCol>
      </Row>
    </Container>
  </Wrapper>
)

export default WhatWeHaveDone
